import { createContext, ReactNode, useMemo } from 'react';
import { useCookies } from 'react-cookie';

import { Auth, Role } from '@bai/utils/types';

import { parseAuthFromCookie } from './AuthProvider.utils';

export const AuthContext = createContext<Auth | null>(null);

interface AuthProviderProps {
  children: ReactNode | ReactNode[];
}

export function AuthProvider({ children }: AuthProviderProps) {
  const [cookies] = useCookies<
    'user' | 'userRole' | 'COOKIE_STORE_RESET',
    {
      user: string;
      userRole: Role;
    }
  >(['user', 'userRole', 'COOKIE_STORE_RESET']);

  const auth = useMemo(
    () => parseAuthFromCookie(cookies.user) ?? null,
    [cookies.user],
  );

  const authWithLegacyRole = useMemo(
    () =>
      ({
        ...auth,
        legacy_userRole: cookies.userRole,
      }) as Auth | null,
    [auth, cookies.userRole],
  );

  return (
    <AuthContext.Provider value={authWithLegacyRole}>
      {children}
    </AuthContext.Provider>
  );
}
